import { ToastOptions, toast } from 'react-toastify'

const showNotification = (message: string, options?: ToastOptions) => toast(message, options)
const showNotificationError = (message: string, options?: ToastOptions) => showNotification(message, { type: 'error', ...options })
const showNotificationWarning = (message: string, options?: ToastOptions) => showNotification(message, { type: 'warning', ...options })
const showNotificationSuccess = (message: string, options?: ToastOptions) => showNotification(message, { type: 'success', ...options })

export default {
  showNotificationError,
  showNotificationSuccess,
  showNotificationWarning,
}
